import { useTranslation } from 'react-i18next';

import type { LogTimeSetting, SettingsSample } from '../sampleData';

/**
 * A level's plain-language label (brief §4.2), naming the Owners legal
 * entity or department it reads: "Everyone in Nordic Consulting A/S".
 */
export const useScopeLabel = (sample: SettingsSample) => {
  const { t } = useTranslation('pmDetails');
  return (setting: LogTimeSetting): string => {
    switch (setting.scope) {
      case 'legalEntity':
        return t('logTime.scope.legalEntity', {
          name: sample.legalEntities.find((e) => e.id === setting.legalEntityId)?.name ?? '',
        });
      case 'department':
        return t('logTime.scope.department', {
          name: sample.departments.find((d) => d.id === setting.departmentId)?.name ?? '',
        });
      default:
        return t(`logTime.scope.${setting.scope}`);
    }
  };
};
